// TODO: Make a breaking change to integrate the logic here with the logic used in UserAgentParser.ts
let _isIPad: boolean | undefined = undefined;
let _isMac: boolean | undefined = undefined;
let _isWindows: boolean | undefined = undefined;
let _isIPhone: boolean | undefined = undefined;
let _isIos: boolean | undefined = undefined;
let _isAndroid: boolean | undefined = undefined;
let _isMobile: boolean | undefined = undefined;

export const isIPad = function (): boolean {
  if (_isIPad === undefined) {
    _isIPad =
      navigator.userAgent.indexOf('iPad') >= 0 ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  }

  return _isIPad;
};

export const isMac = function (): boolean {
  if (_isMac === undefined) {
    _isMac =
      navigator.userAgent.indexOf('Macintosh') >= 0 &&
      // Make sure it's not an iPad
      !('ontouchend' in document);
  }

  return _isMac;
};

export const isWindows = function (): boolean {
  if (_isWindows === undefined) {
    _isWindows = navigator.platform.indexOf('Win') >= 0;
  }

  return _isWindows;
};

export const isIPhone = function (): boolean {
  if (_isIPhone === undefined) {
    _isIPhone = navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPod') >= 0;
  }

  return _isIPhone;
};

export const isIOS = function (): boolean {
  if (_isIos === undefined) {
    _isIos =
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  }

  return _isIos;
};

export const isAndroid = function (): boolean {
  if (_isAndroid === undefined) {
    _isAndroid = navigator.userAgent.indexOf('Android') >= 0;
  }

  return _isAndroid;
};

export const isMobile = function (): boolean {
  if (_isMobile === undefined) {
    _isMobile =
      /Android|BlackBerry|Windows Phone|IEMobile|Opera Mini|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      isIOS() ||
      isAndroid();
  }

  return _isMobile;
};

export const isAndroidPhone = function (): boolean {
  return isAndroid() && navigator.userAgent.indexOf('Mobile') >= 0;
};

export const isAndroidTablet = function (): boolean {
  return isAndroid() && navigator.userAgent.indexOf('Mobile') === -1;
};
